const ACTIONABLE_RECALCULATION_KEYS = Object.freeze({
  SKIPPED_MISSING_EMISSION_FACTOR:
    'dataInput.mutationResult.sourceSavedMissingEmissionFactor',
  SKIPPED_MISSING_SOURCE:
    'dataInput.mutationResult.sourceSavedMissingSource',
  SKIPPED_INCOMPLETE_EF:
    'dataInput.mutationResult.sourceSavedIncompleteEmissionFactor',
});

const feedback = (severity, {
  messageKey = null, message = null, params = {},
} = {}) => ({
  severity,
  messageKey,
  message,
  params,
});

export default function mutationFeedback(result, {
  successMessageKey = null,
  successMessage = null,
  successParams = {},
} = {}) {
  const recalculation = result?.recalculation || result?.operation?.recalculation;
  const outcome = String(recalculation?.outcome || '').toUpperCase();
  const reasonCode = recalculation?.reasonCode || recalculation?.reason_code;
  const requiresRecovery = Boolean(
    result?.requires_recovery ?? result?.requiresRecovery,
  );
  if (outcome === 'FAILED' || requiresRecovery) {
    return feedback('error', {
      messageKey: 'dataInput.mutationResult.sourceSavedCalculationFailed',
    });
  }
  if (outcome === 'SKIPPED' && ACTIONABLE_RECALCULATION_KEYS[reasonCode]) {
    return feedback('warning', {
      messageKey: ACTIONABLE_RECALCULATION_KEYS[reasonCode],
    });
  }
  return feedback('success', {
    messageKey: successMessageKey,
    message: successMessage,
    params: successParams,
  });
}
